import defaultMember from './defaultMember';
import defaultStorage from './defaultStorage';
import getHCStorage from './getHCStorage';
import loadData from './loadData';
import storePhoneNumber from './storePhoneNumber';
import getDefaultMember from './getDefaultMember';
import storeContactData from './storeContactData';
import getInvalidPhonesOnDemand from './getInvalidPhonesOnDemand';

export default {
  defaultMember,
  defaultStorage,
  getHCStorage,
  loadData,
  storePhoneNumber,
  getDefaultMember,
  storeContactData,
  getInvalidPhonesOnDemand,
};
